import { parseISO } from 'date-fns/parseISO';
import * as React from 'react';
import { Lazyloader } from '../Lazyloader/Lazyloader';
import { TimeElement } from '../TimeElement/TimeElement';
import { type NewsArticlePage } from '../Types';

export interface INewsArchiveListProps {
    items: NewsArticlePage[];
}

export class NewsArchiveList extends React.Component<INewsArchiveListProps> {
    constructor(props: INewsArchiveListProps) {
        super(props);
    }

    public renderItem(item: NewsArticlePage): JSX.Element {
        return (
            <div className="news-module__news-box col-12 col-sm-6 col-lg-4 news-module--grey-box" key={item.url}>
                <a href={item.url} className="fold fold--orange">
                    <Lazyloader image={item.image} hasVideo={item.hasVideo} isBackgroundImage={false} />
                    <p className="news-archive__date">
                        <span>
                            <TimeElement date={parseISO(item.date)}>{item.publishedDate}</TimeElement>
                        </span>
                    </p>
                    <div className="news-module__text news-module--text">
                        <h3 className="h4">{item.title}</h3>
                        <div>
                            {item.newsCategory ? <span className="news-module__news-category">{item.newsCategory} · </span> : null}
                            {item.summary}
                        </div>
                    </div>
                </a>
            </div>
        );
    }

    public render(): JSX.Element {
        return <div className="row news-module">{this.props.items.map(this.renderItem)}</div>;
    }
}
